import {
	Account,
	AccountSettings,
	NotificationSetting,
	Product,
	Survey,
	User,
	UserSettings,
} from '@state/session/models';

export const sessionStateKey = 'session';

export interface SessionState {
	data: {
		user: User;
		account: Account;
		products: Array<Product>;
		survey: Survey;
	};
	settings: {
		user: UserSettings;
		account: AccountSettings;
		notifications: Array<NotificationSetting>;
	};
	loggedIn: boolean;
	nextUpdate: string
}

export const initialState: SessionState = <SessionState>{};
